<template>
  <div>
    <div class="container py-3">
    <a-list item-layout="vertical" size="large" :data-source="listData">
      <a-list-item slot="renderItem" key="item.title" slot-scope="item">

        <img
          v-if="!loading"
          slot="extra"
          width="272"
          alt="logo"
          src="https://gxscloud.oss-cn-shanghai.aliyuncs.com/efind/backgroundImage/bigSnow.jpg"
        />
        <a-skeleton :loading="loading" active avatar>
          <a-list-item-meta :description="item.description">
            <a slot="title" :href="item.href">{{ item.title }}</a>
            <a-avatar slot="avatar" :src="item.avatar" />
          </a-list-item-meta>
          {{ item.content }}
        </a-skeleton>
      </a-list-item>
    </a-list>
    </div>
  </div>
</template>
<script>
const listData = [];
for (let i = 0; i < 8; i++) {
  listData.push({
    title: '沁园春·长沙',
    avatar: 'https://gxscloud.oss-cn-shanghai.aliyuncs.com/Avatar/defaultAvatar.png',
    description:
      `广告位展示 ${i}`,
    content:
      '独立寒秋，湘江北去，橘子洲头。看万山红遍，层林尽染；漫江碧透，百舸争流。鹰击长空，鱼翔浅底，万类霜天竞自由。怅寥廓，问苍茫大地，谁主沉浮？携来百侣曾游，忆往昔峥嵘岁月稠。恰同学少年，风华正茂；书生意气，挥斥方遒。指点江山，激扬文字，粪土当年万户侯。曾记否，到中流击水，浪遏飞舟！',
  });
}
export default {
  data() {
    return {
      loading: false,
      listData,
      actions: [
        { type: 'star-o', text: '156' },
        { type: 'like-o', text: '156' },
        { type: 'message', text: '2' },
      ],
    };
  },
  methods: {
    onChange(checked) {
      this.loading = !checked;
    },
  },
};
</script>
<style>
.skeleton-demo {
  border: 1px solid #f4f4f4;
}
</style>
